import "../../chunk-7QVYU63E.js";
var Permission = /* @__PURE__ */ function(Permission2) {
  Permission2["ManageTeamSettings"] = "manage_team_settings";
  Permission2["ViewTeamSettings"] = "view_team_settings";
  Permission2["ManageMembers"] = "manage_members";
  Permission2["AssignRoles"] = "assign_roles";
  Permission2["ManageAdminApiKeys"] = "manage_admin_api_keys";
  Permission2["CreateApps"] = "create_apps";
  Permission2["DeleteApps"] = "delete_apps";
  Permission2["ViewApps"] = "view_apps";
  Permission2["ViewAppLogs"] = "view_app_logs";
  Permission2["ViewAppConfig"] = "view_app_config";
  Permission2["EditAppConfig"] = "edit_app_config";
  Permission2["ManageWebhooks"] = "manage_webhooks";
  Permission2["ViewActivityLog"] = "view_activity_log";
  Permission2["ViewApiKeys"] = "view_api_keys";
  Permission2["RotateKey"] = "rotate_key";
  Permission2["ViewActivityLogWebhooks"] = "view_activity_log_webhooks";
  Permission2["ManageActivityLogWebhooks"] = "manage_activity_log_webhooks";
  return Permission2;
}({});
export {
  Permission
};
//# sourceMappingURL=permission.js.map